import React, { useState, useEffect } from "react"
import { useAppCtx, appStore } from "lib/state"
import { appTools, cn } from "lib/utils"
// import { ImageGrid } from "lib/components"
import ImageManager from "lib/modules/ImageManager/ImageManager"
import SectionHeaderRender from "lib/units/element/SectionHeader/SectionHeaderRender"
import { useRenderStyling, renderStyle } from "lib/hooks/useRenderStyling"
import { getApiFeedData } from "./utils"
import { image } from "pages/devtools/coderunner/__core/helpers"

export default function SupportingImagesRender({
  mode="preview",
  renderPkg,
}:{
  mode:string
  renderPkg:any
}) {

  const { store, AppStore } = appStore() 
  const { update } = AppStore

  // const { mode, subdomain, getElementConfig, getApiFeedData }:any = useTemplatePreviewCtx() 
  // const config = getElementConfig("supporting_images")

  const settings = renderPkg.dispute.elements.find((setting:any) => setting.refstr === "supporting_images").settings || {}

  const [ finalConfig, setFinalConfig ] = useState<any>({}) 
  const [ images, setImages ] = useState<any>({ checked: false, data: []})
  const [ hiddenImageIds, setHiddenImageIds ] = useState<any[]>([])

  const hideImage = (Id:any) => {
    setHiddenImageIds([...hiddenImageIds, Id])
  }

  useEffect(() => {
    const imagesToLoad = getApiFeedData(renderPkg.clientdata, "rp.Documents")  
    setImages({ checked: true, data: imagesToLoad || [] })
  },[])

  const prepFinalConfig = () => {
    const final = {
      ready: true,
      settings: {
        title: settings?.title || "Supporting Images",
        maxToShow: settings?.maxToShow || 999,
        filter: settings?.filter || null,
        sortBy: settings?.sortBy || null,
        imageLayout: settings?.imageLayout || "vertical",
        displayIfNoImages: settings?.displayIfNoImages || false,
        showImageTitles: settings?.showImageTitles || true,
        showImageDescriptions: settings?.showImageDescriptions || true,
        metaDataFormat: settings?.metaDataFormat || "horizontal"
      }
    }
    setFinalConfig(final)
  }

  const getMeasurements = () => {
    const container = document.getElementById("mm-supporting-images")
    if( container ){
      const containerWidth = container.clientWidth
      const containerHeight = container.clientHeight
      update("preview.measurements.supportingImagesContainer", containerHeight )
    }
  }

  const outerStyling = useRenderStyling("mm-section w-full flex flex-col", "styleObj")
  const innerStyling = useRenderStyling("w-full flex flex-col justify-start items-start pl-2 pr-6 mt-3 mb-6", "styleObj")
  const outerImage = useRenderStyling("w-full flex flex-col pl-2 mb-8 w-21/24", "styleObj")
  const outerCaption = useRenderStyling("border-b border-b-solid border-b-neutral-400 pb-1 mb-2", "styleObj")
  const captionTitle = useRenderStyling("font-semibold text-lg", "styleObj")
  const captionBody = useRenderStyling("text-xs leading-tight", "styleObj")


  // useEffect(() => {
  //   if( finalConfig.ready ){
  //     getMeasurements()
  //   }
  // },[finalConfig])

  useEffect(() => {
    prepFinalConfig()
  },[])

  if( !finalConfig.ready || !images.checked || (images.checked === true && images.data?.length === 0) ) return <></>
  return (
    <div id="mm-supporting-images" {...outerStyling}>
      
      <SectionHeaderRender title="Supporting Images" />

      <div {...innerStyling}>
        {/* <ImageGrid 
          imageUrls={images.map( (img:any) => ({...img, src: `https://${renderPkg.subdomain}.midmetrics.io/${img.Src}` }) )}  
        /> */}

        { store.preview.editing?.action === "image-manager" ? (
          <ImageManager />
        ) : images?.data.length > 0 && images?.data.map( (item:any, idx:number) => (
          <div 
            key={item.Id} 
            className={cn("supporting-image-container", idx === 0 && "first")}
            style={{ display: "block", pageBreakInside: "avoid", breakInside: "avoid" }}
          >
            <div {...outerImage}>
              <div {...outerCaption}> 
                <h3 {...captionTitle}>{item.Title}</h3>
                <div {...captionBody}>{item.Notes}</div>
              </div>
              <img 
                src={`https://${renderPkg?.subdomain}.midmetrics.io/${item.Src}`} 
                alt={`Image ${idx}`} 
                style={{ width: "90%", height: "90%", maxWidth: "100%", maxHeight: "100%" }}  
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}